import { useContext } from 'react'

import Modal from '@/components/view/layouts/modal/Modal'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import OrderCsvUploadForm from '@/components/container/form/modules/master/csvUpload/OrderCsvUploadForm'

import { OrderCsvUploadModalContext } from './OrderCsvUploadModalProvider'

const OrderCsvUploadModal = () => {
  const { modal, showing, hide } = useContext(OrderCsvUploadModalContext)

  return (
    <Modal show={showing}>
      <ModalHeader text='受注を登録する' onClickClose={hide} />
      <OrderCsvUploadForm
        siteId={modal.siteId}
        onClickClose={() => {
          hide()
          modal.onClose()
        }}
      />
    </Modal>
  )
}

export default OrderCsvUploadModal
